import events from './events.js';
import modal from '../../smartpak/modal.js';

function createConfirmDialog(options) {
    var opts = options || {},
        modalInstance = modal($('<p>' + opts.content + '</p>').get(0), {
            title: opts.title,
            modal: true,
            resizable: false,
            modalClass: 'wizard-exit-modal',
            open: function () {
                events.fireConfirmModalOpenEvent();
            },
            buttons: [
                {
                    text: opts.okButtonText,
                    click: function () {
                        modalInstance.close();
                        events.fireConfirmModalCancelEvent();
                    }
                },
                {
                    text: opts.cancelButtonText,
                    click: function () {
                        if (options.url) {
                            location.href = options.url;
                        }
                        modalInstance.close();
                        events.fireConfirmModalConfirmEvent();
                    }
                }
            ]
        });

    return modalInstance;
}

function buildContent(sectionText) {
    return `If you exit, <strong>you&rsquo;ll lose all of your progress</strong> in ${
        sectionText ? `the ${sectionText}` : 'this'
    } Section.`;
}

export function confirmationModal(sectionText = '', url) {
    return createConfirmDialog({
        title: 'Are you sure you want to exit?',
        content: buildContent(sectionText),
        okButtonText: 'No, not yet',
        cancelButtonText: 'Yes, I&rsquo;m sure',
        url
    });
}

export function doneConfirmationModal(sectionText, url) {
    return createConfirmDialog({
        title: 'Are you sure you want to exit?',
        content: buildContent(),
        okButtonText: 'No, not yet',
        cancelButtonText: 'Yes, I&rsquo;m done',
        url
    });
}

export function backConfirmationModal(sectionText, url) {
    return createConfirmDialog({
        title: 'Are you sure you want to go back?',
        content: `If you choose to go back <strong>you&rsquo;ll lose all of your progress</strong> in the ${sectionText} Section.`,
        okButtonText: 'No, not yet',
        cancelButtonText: 'Yes, go back',
        url
    });
}
